import React from 'react';
import { classNames } from 'primereact/utils';

import EzControlledRadioButton from '../';

const EzControlledRadioButtonWithLabel = (props) => {
  const {
    control,
    name,
    value,
    rules,
    onChange,
    labelClassName,
    wrapperClass,
    label,
    errorMsg,
    isError,
  } = props;

  const renderLabel = () => {
    const lblClass = classNames({ 'p-error': isError }, labelClassName);

    return (
      <label htmlFor={name} className={lblClass}>
        {rules?.required ? `${label}*` : label}
      </label>
    );
  };

  return (
    <div className={wrapperClass}>
      <EzControlledRadioButton
        name={name}
        value={value}
        onChange={onChange}
        control={control}
        rules={rules}
      />
      {renderLabel()}
      {errorMsg}
    </div>
  );
};

EzControlledRadioButtonWithLabel.defaultProps = {
  labelClassName: '',
  wrapperClass: 'field-checkbox flex-row',
};

export default EzControlledRadioButtonWithLabel;
